<template>
  <div style="width: 100%; min-height: 100vh; background-color: #f1f1f1; padding-bottom: 50px">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7; z-index: 222" title="会员互转" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <div style="background: #fff; box-sizing: border-box; padding: 0 20px">
      <div class="qibao">
        <div class="fes">中心钱包余额</div>
        <div class="imgs"><img @click="$parent.getUserInfoShowLoding()" src="/static/image/iconRefresh.5b108ae65439270527aeee8ac17c2aca.png" alt="" /></div>
      </div>
      <div class="meys"><span>￥</span>{{ $store.state.userInfo.balance }}</div>
    </div>

    <div class="usrse">
      <div class="hgs">
        <div class="nams">对方会员号</div>
        <div>
          <van-cell-group>
            <van-field v-model="username" type="text" autocomplete="off" placeholder="请输入对方会员账号"> </van-field>
          </van-cell-group>
        </div>
      </div>
      <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
      <div class="hgs">
        <div class="nams">转账金额</div>
        <div>
          <van-cell-group>
            <van-field v-model="amount" type="number" placeholder="请输入转账金额">
              <template #button> <van-button size="mini" @click="amount = $store.state.userInfo.balance" type="info">最大金额</van-button> </template>
            </van-field>
          </van-cell-group>
        </div>
      </div>
      <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
      <div class="hgs">
        <div class="nams">支付密码</div>
        <div>
          <van-cell-group>
            <van-field v-model="password" type="password" autocomplete="new-password" placeholder="请输入支付密码"> </van-field>
          </van-cell-group>
        </div>
      </div>
      <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
    </div>

    <div style="margin: 0 auto; width: 86%">
      <van-button type="info" style="margin-top: 20px; width: 100%" :loading="submitting" :disabled="submitting" @click="doTransfer">确认转账</van-button>
      <div class="textcns" style="text-align: center; color: #999; padding: 10px 0">转账前请仔细核对对方会员号，转账成功后无法撤回</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'memberTransfer',
  data() {
    return {
      username: null,
      amount: null,
      password: null,
      submitting: false,
    };
  },
  methods: {
    doTransfer() {
      let that = this;
      if (that.submitting) {
        return;
      }
      let username = that.username ? that.username.trim() : '';
      let amount = that.amount;
      let password = that.password;
      if (!username) {
        that.$parent.showTost(0, '请输入对方会员账号');
        return;
      }
      if (username == that.$store.state.userInfo.username) {
        that.$parent.showTost(0, '不能转账给自己');
        return;
      }
      if (!amount || amount * 1 <= 0) {
        that.$parent.showTost(0, '请输入正确的转账金额');
        return;
      }
      if (amount * 1 > that.$store.state.userInfo.balance * 1) {
        that.$parent.showTost(0, '中心钱包余额不足');
        return;
      }
      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$dialog
        .confirm({
          title: '确认转账',
          message: `确定将 ${amount} 元转给会员【${username}】吗？`,
        })
        .then(() => {
          that.submitting = true;
          that.$parent.showLoading();
          that.$apiFun
            .post('/api/membertransfer', { username, amount, password })
            .then(res => {
              if (res.code != 200) {
                that.$parent.showTost(0, res.message || '转账失败');
              }
              if (res.code == 200) {
                that.$parent.showTost(1, '转账成功');
                that.username = null;
                that.amount = null;
                that.password = null;
                that.$parent.getUserInfoShowLoding();
              }
              that.$parent.hideLoading();
            })
            .catch(() => {
              that.$parent.showTost(0, '网络连接错误，请稍后再试');
              that.$parent.hideLoading();
            })
            .finally(() => {
              that.submitting = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.qibao {
  display: flex;
  align-items: center;
  padding-top: 15px;
  .fes {
    font-size: 0.38rem;
    font-weight: 700;
    color: #000;
  }
  .imgs {
    margin-left: 10px;
    img {
      width: 0.45rem;
      display: block;
    }
  }
}
.meys {
  font-size: 0.7rem;
  font-weight: 700;
  color: #597ef7;
  padding: 10px 0 15px;
  span {
    font-size: 0.4rem;
  }
}
.usrse {
  margin-top: 0.2rem;
  background: #fff;
  .hgs {
    width: calc(100% - 40px);
    margin: 0 auto;
  }
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/memberTransfer.vue